export default "__VITE_ASSET__DKh9SkoU__"